import { types } from '../shared/types/types';

// const state = {
//     name: 'Fernando',
//     logged: true
// }

export const appReducer = (state = {}, action ) => {

    switch ( action.type ) {
        case types.login:
            return {
                ...state,
                logged: action.payload.logged,
                name: action.payload.name
            }

        case types.logout:
            return {
                ...state,
                name: '',
                logged: false,
                submenu: "",
                consultar: 0,
                editar: 0,
                eliminar: 0,
                adicionar:  0
            }

        case types.updateUser:
            return {
                ...action.payload,
            }
        case types.loader:
            return {
                ...state,
                load: action.payload,
            }
        case types.showMenu:
            return {
                ...state,
                showMenu: action.payload,
            }

        case types.authTrue:
            if (action.payload) {
                return {
                    ...state,
                    logged: action.payload.login,
                    name: action.payload.nombre
                };
            } else {
                return {
                    ...state,
                    logged: action.payload,
                    name: ''
                };
            }

        case types.updatePermis:
            return {
                ...state,
                submenu: action.payload.submenu,
                consultar: action.payload.consultar,
                editar: action.payload.editar,
                eliminar: action.payload.eliminar,
                adicionar: action.payload.adicionar,
            }
        case types.contratomarcoId:
            return {
                ...state,
                contratomarcoId: action.payload,
            }
        default:
            return state;
    }

}
